import { Injectable } from '@angular/core';
import { Password } from '@app/modules/shipper/models/profile/password';
import { profile } from '@app/modules/shipper/models/profile/profile';
import { Observable } from 'rxjs';
import { CommonHttpService } from './common-http.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor( private commonHttpService: CommonHttpService) { }

  public getProfile(endpoint:string):Observable<any>{
    return this.commonHttpService.get<any>(endpoint);
  }

  public editProfile(endpoint:string,argLoadModel: profile):Observable<any>{
    return this.commonHttpService.put<profile, profile>(endpoint, argLoadModel);    
  }

  public editPassword(endpoint:string,argLoadModel: Password):Observable<any>{
    return this.commonHttpService.put<profile, profile>(endpoint, argLoadModel);    
  }
}
